import axios from "axios";
import React, { Component } from "react";
import { apiCall_domain } from "../../api";
import Header from "../../header";
import Spinner from "../../Spinner/Spinner";
import Delivery from "../delivery";
import Payment from "../PaymentMeth";
import PriceWrapper from "../PriceWrapper";
import PulseLoader from "react-spinners/PulseLoader";
import { toast } from "react-hot-toast";
export default class Checkout extends Component {
  state = {
    step: "delivery", // delivery , payment
    selectedAddress: null,
    selectedDelivery: null,
    selectedPayment: null,
    selectedBank: null,
    nationalCode: "",
    description: null,
    products: null,
    withServiceProducts: [],
    withOutServiceProducts: [],
    hasTire: false,
    hasService: false,
    hasWithoutService: false,
    discountCode: null,
    costs: null,
    time_id: null,
    shoppingCardId: null,
    loading: true,
    discountLoading: false,
    discountSubmited: false,
    can_pay_cash: null,
    haveOrg: false,
    organFiles: [],
    organFilesName: [],
    month: "2",
    selectedOrgan: { label: "", value: { id: 0, limit_price: 0 } },
    dTypes: [],
    selectedForeignCollect: null,
    legal_id: 0,
    needLegalFactor: false,
  };
  componentDidMount() {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };

    const splash = localStorage.getItem("splash");
    const parsedSplash = JSON.parse(splash);
    this.setState({
      legal_id: parsedSplash?.legal_info?.id || 0,
    });
    axios
      .get(`${apiCall_domain}/customer/shopping-cart`, {
        headers: config,
      })
      .then((res) => {
        const items = [];
        const products = [];
        res.data.data.types.map((type) => {
          items.push(...type.items);
        });
        let withServiceProducts = [];
        let withOutServiceProducts = [];
        let hasTire = false;
        let hasService = false;
        let hasWithoutService = false;
        items.map((product) => {
          if (product.is_tire == 1) {
            hasTire = true;
          }
          let item;
          if (product.install_need == 1) {
            hasService = true;
            if (product.service_type == 1) {
              item = {
                name: product.name,
                count: product.count,
                address: product.address,
                time_id: product?.time.id,
                id: product.vendor_item_id,
                date: product.date.gregorian,
                vendor_id: product.vendor_id,
                address_id: product.address_id,
                install_need: product.install_need,
                service_type: product.service_type,
                time: product?.time,
                dates: product.date,
                is_organization: product.is_organization,
              };
            }
            if (product.service_type == 0) {
              item = {
                name: product.name,
                count: product.count,
                depot: product.depot,
                time_id: product?.time?.id,
                time: product?.time,
                is_organization: product.is_organization,

                id: product.vendor_item_id,
                depot_id: product.depot_id,

                date: product.date.gregorian,
                vendor_id: product.vendor_id,
                install_need: product.install_need,
                service_type: product.service_type,
                dates: product.date,
              };
            }
            withServiceProducts.push(item);
          } else {
            hasWithoutService = true;
            item = {
              count: product.count,
              id: product.vendor_item_id,
              is_organization: product.is_organization,

              install_need: product.install_need,
            };
            withOutServiceProducts.push(item);
          }
        });
        this.calculate(
          [...withOutServiceProducts, ...withServiceProducts],
          0,
          this.state.selectedAddress?.id || null,
          this.state.selectedDelivery || 1,
          this.state.discountCode || null,
        );

        this.setState({
          products: [...withOutServiceProducts, ...withServiceProducts],
          hasService,
          hasWithoutService,
          hasTire,
          shoppingCardId: res.data.data.id,
          loading: false,
          haveOrg:
            [...withOutServiceProducts, ...withServiceProducts].filter(
              (p) => p.is_organization === 1,
            ).length ===
            [...withOutServiceProducts, ...withServiceProducts].length
              ? true
              : false,
          step: hasWithoutService ? "delivery" : "payment",
        });
      });
  }

  uploadFile = (file) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
    };
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
      headers: headers,
    });
  };

  uploadImages = () => {
    return new Promise((resolve, reject) => {
      if (this.state.organFiles.length) {
        this.state.organFiles.map((image) => {
          this.uploadFile(image).then((res) => {
            if (res.data.success) {
              this.setState({
                organFilesName: [...this.state.organFilesName, res.data.name],
              });
            } else {
              toast.error("خطا در آپلود عکس");
            }
            if (
              this.state.organFilesName.length === this.state.organFiles.length
            ) {
              resolve();
            }
          });
        });
      } else {
        toast.error("برای خرید قرار دادی باید عکس اپلود کنید");
      }
    });
  };

  handleChangeSelectedForeignCollect = (value) => {
    this.setState({ selectedForeignCollect: value }, () => {
      this.calculate();
    });
  };
  calculate = async (
    products,
    isMajor,
    addressId = null,
    shipping = 1,
    discountCode = null,
  ) => {
    this.setState({ showDiscount: true });
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    let itemsList = "";
    products?.map((item, index) => {
      const itemDetail = {
        id: item.id,
        count: item.count,
        install_need: item.install_need,
      };
      if (item.install_need === 1) {
        const installNeedItem = {
          date: item.date,
          time_id: item.time,
          service_type: item.service_type,
          ...(item.address_id
            ? { address_id: item.address_id }
            : { depot_id: item.depot_id }),
        };
        Object.assign(itemDetail, installNeedItem);
      }
      for (const [key, value] of Object.entries(itemDetail)) {
        itemsList += `&items[${index}][${key}]=${value}`;
      }
    });
    await axios
      .get(
        `${apiCall_domain}/customer/orders/calculation?shipping=${shipping}&is_web=1${itemsList}&is_organization=${
          this.state.haveOrg === true ? 1 : 0
        }&is_major=${isMajor}${
          addressId === null ? "" : `&address_id=${addressId}`
        }${
          discountCode === null
            ? this.state.haveOrg === true
              ? ""
              : ""
            : `&discount_code=${discountCode}`
        }`,
        { headers: config },
      )
      .then((res) => {
        this.setState({
          costs: res.data,
          discountLoading: false,
          can_pay_cash: res.data.can_pay_cash,
        });
        if (discountCode) {
          this.setState({
            discountSubmited: true,
            discountLoading: false,
          });
          toast.success("کد تخفیف اعمال شد");
        } else if (discountCode === "") {
          this.setState({
            discountSubmited: false,
            discountLoading: false,
          });
          toast.success("کد تخفیف حذف شد");
        }
      })
      .catch((err) => {
        this.setState({
          discountLoading: false,
        });
        toast.error(err?.response?.data?.errors?.items[0], {
          duration: 7000,
        });
      });
  };
  changeDeliveryType = (id) => {
    this.setState({ selectedDelivery: id }, () => {
      this.fetchFreightCollects();
      this.calculate(
        this.state.products,
        0,
        this.state.selectedAddress?.id || null,
        this.state.selectedDelivery,
        this.state.discountCode || null,
      );
    });
  };
  submitDiscountCode = () => {
    this.setState({ discountLoading: true }, () => {
      this.calculate(
        this.state.products,
        0,
        this.state.selectedAddress?.id,
        this.state.selectedDelivery,
        this.state.discountCode,
      );
    });
  };
  clearDiscountCode = () => {
    this.setState({ discountLoading: true, discountCode: "" }, () => {
      this.calculate(
        this.state.products,
        0,
        this.state.selectedAddress?.id,
        this.state.selectedDelivery,
        this.state.discountCode,
      );
    });
  };
  changeSelectedAddress = (address) => {
    this.setState({ selectedAddress: address });
  };
  changeStep = (step) => {
    this.setState({ step });
  };

  fetchFreightCollects = () => {
    this.getFreightCollects().then((r) =>
      this.setState({ dTypes: r.data.data }),
    );
  };

  getFreightCollects = () => {
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    return axios.get(`${apiCall_domain}/customer/orders/getFreightCollects`, {
      headers: config,
    });
  };
  changeNationalCode = (e) => {
    const nationalCode = e.target.value;
    const numberRegex = /^[+-]?\d*(?:[0-9]\d*)?$/;
    if (numberRegex.test(nationalCode) && nationalCode.length <= 10) {
      this.setState({ nationalCode: nationalCode });
    }
  };
  handleChangeOrgan = (v) => {
    this.setState({ selectedOrgan: v });
  };
  handleFile = (file) => {
    this.setState({ organFiles: file });
  };
  handleInstallmentMonth = (v) => {
    this.setState({ month: v });
  };
  changePaymentType = (paymentType) => {
    this.setState({ selectedPayment: paymentType, selectedBank: null });
    this.calculate(
      this.state.products,
      0,
      this.state.selectedAddress?.id,
      this.state.selectedDelivery,
      this.state.discountCode,
    );
  };
  changeBank = (bank) => {
    this.setState({ selectedBank: bank });
  };
  changeDescription = (description) => {
    this.setState({ description: description.target.value });
  };

  changeDiscoutCode = (code) => {
    this.setState({ discountCode: code.target.value });
  };

  handleSubmit = () => {
    console.log(this.state.needLegalFactor, this.state.legal_id);
    this.setState({ submitLoading: true });
    const config = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    if (this.state.selectedPayment === 0) {
      const Data = {
        customer_legal_id:
          this.state.needLegalFactor && this.state.legal_id
            ? this.state.legal_id
            : null,
        gest_count: this.state.month,
        address_id: this.state.hasWithoutService
          ? this.state.selectedAddress.id
          : null,
        delivery_type: 0,
        depot_id: null,
        dev_type: 3,
        discount_code: this.state.discountCode,
        pay_bank: null,
        pay_type: 0,
        shipping: this.state.selectedDelivery || 0,
        text: this.state.description,
        chassis_number: "",
        national_id: this.state.nationalCode,
        plaque: "",
        vendor_id: null,
        is_major: 0,
        time: "",
        is_installment: 0,
        items: this.state.products,
        time_id: this.state.time_id,
        organ_id: this.state.selectedOrgan.value.id,
        freightCollect_id: this.state.selectedForeignCollect?.id,
      };
      if (this.state.selectedOrgan.value.id !== 0) {
        if (
          this.state.costs.price <= this.state.selectedOrgan.value.limit_price
        ) {
          this.uploadImages().then(() => {
            axios
              .post(
                `${apiCall_domain}/customer/organs/upload/document`,
                this.state.organFilesName,
                { headers: config },
              )
              .then(() =>
                axios
                  .post(`${apiCall_domain}/customer/orders/submit`, Data, {
                    headers: config,
                  })
                  .then((res) => {
                    toast.success(
                      "سفارش شما ثبت شد بعد از بررسی توسط تیم پشتیبانی با شما تماس خواهند گرفت",
                    );
                    if (res.data.pay_details) {
                      window.location.replace(res.data.pay_details.url);
                    } else {
                      this.props.history.push(
                        `/paymentResult?status=registered`,
                      );
                    }
                    localStorage.setItem(
                      "orderPrice",
                      this.state.costs.final_price,
                    );
                    localStorage.setItem(
                      "ordinaryCartId",
                      this.props.data.ordinaryCartId,
                    );
                  })
                  .catch((err) => {})
                  .finally(() => {
                    this.setState({ submitLoading: false });
                  }),
              );
          });
        } else {
          this.setState({ submitLoading: false });

          toast.error("قیمت سبد خرید شما بیشتر از مبلغ قرار داد است");
        }
      } else {
        this.setState({ submitLoading: false });

        toast.error("برای خرید قراردادی باید شرکت مورد نظر را انتخاب کنید");
      }
    } else if (this.state.selectedPayment === 5) {
      const Data = {
        customer_legal_id:
          this.state.needLegalFactor && this.state.legal_id
            ? this.state.legal_id
            : null,
        address_id: this.state.hasWithoutService
          ? this.state.selectedAddress.id
          : null,
        delivery_type: 0,
        depot_id: null,
        dev_type: 3,
        discount_code: this.state.discountCode,
        pay_bank: 1,
        pay_type: 1,
        shipping: this.state.selectedDelivery || 0,
        text: this.state.description,
        chassis_number: "",
        national_id: this.state.nationalCode,
        plaque: "",
        vendor_id: null,
        is_major: 0,
        time: "",
        is_installment: 0,
        items: this.state.products,
        dargah: true,
        freightCollect_id: this.state.selectedForeignCollect?.id,
      };
      if (!this.state.submitLoading) {
        axios
          .post(`${apiCall_domain}/customer/orders/submit`, Data, {
            headers: config,
          })
          .then((res) => {
            localStorage.setItem("orderPrice", this.state.costs.final_price);
            this.setState({ submitLoading: false });
            this.clearCart(this.state.shoppingCardId);
            const paymentForm = document.createElement("form");
            paymentForm.method = "POST";
            paymentForm.action = res.data.paymentUrl;

            const paymentToken = document.createElement("input");
            paymentToken.type = "hidden";
            paymentToken.name = "payment_token";
            paymentToken.value = res.data.paymentToken; // Use the payment token from the response

            paymentForm.appendChild(paymentToken);
            document.body.appendChild(paymentForm);
            // Submit the form to initiate the payment
            paymentForm.submit();
          })
          .catch((err) => {
            toast.error(err?.response?.data?.errors?.items[0], {
              duration: 7000,
            });
          });
      }
    } else if (this.state.selectedPayment === 6) {
      const Data = {
        address_id: this.state.hasWithoutService
          ? this.state.selectedAddress.id
          : null,
        delivery_type: 0,
        depot_id: null,
        dev_type: 3,
        discount_code: this.state.discountCode,
        pay_bank: 1,
        pay_type: 1,
        shipping: this.state.selectedDelivery || 0,
        text: this.state.description,
        chassis_number: "",
        national_id: this.state.nationalCode,
        plaque: "",
        vendor_id: null,
        is_major: 0,
        time: "",
        is_installment: 0,
        items: this.state.products,
        zarinPal: 1,
        dargah: false,
        freightCollect_id: this.state.selectedForeignCollect?.id,
        customer_legal_id:
          this.state.needLegalFactor && this.state.legal_id
            ? this.state.legal_id
            : null,
      };
      if (!this.state.submitLoading) {
        axios
          .post(`${apiCall_domain}/customer/orders/submit`, Data, {
            headers: config,
          })
          .then((res) => {
            localStorage.setItem("orderPrice", this.state.costs.final_price);
            this.setState({ submitLoading: false });
            this.clearCart(this.state.shoppingCardId);
            if (this.state.selectedPayment === 6) {
              window.location.replace(res.data.url);
            } else {
              this.props.history.push(`/paymentResult?status=registered`);
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.errors?.items[0], {
              duration: 7000,
            });
          });
      }
    } else {
      const Data = {
        freightCollect_id: this.state.selectedForeignCollect?.id,
        customer_legal_id:
          this.state.needLegalFactor && this.state.legal_id
            ? this.state.legal_id
            : null,
        address_id: this.state.hasWithoutService
          ? this.state.selectedAddress.id
          : null,
        delivery_type: 0,
        depot_id: null,
        dev_type: 3,
        discount_code: this.state.discountCode,
        pay_bank: this.state.selectedBank,
        pay_type: this.state.selectedPayment,
        shipping: this.state.selectedDelivery || 0,
        text: this.state.description,
        chassis_number: "",
        national_id: this.state.nationalCode,
        plaque: "",
        vendor_id: null,
        is_major: 0,
        time: "",
        is_installment: 0,
        items: this.state.products,
        time_id: this.state.time_id,
      };
      if (!this.state.submitLoading) {
        axios
          .post(`${apiCall_domain}/customer/orders/submit`, Data, {
            headers: config,
          })
          .then((res) => {
            localStorage.setItem("orderPrice", this.state.costs.final_price);
            this.setState({ submitLoading: false });
            this.clearCart(this.state.shoppingCardId);
            if (this.state.selectedPayment === 1) {
              window.location.replace(res.data.pay_details.url);
            } else {
              this.props.history.push(`/paymentResult?status=registered`);
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.errors?.items[0], {
              duration: 7000,
            });
          });
      }
    }
  };

  handleChangeNeedLegalFactor = (e) => {
    this.setState({ needLegalFactor: e.target.checked });
  };
  selectedTime = (event) => {
    this.setState({ time_id: event.target.value.id });
  };

  clearCart = (id) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios.post(
      `${apiCall_domain}/customer/shopping-cart/${id}`,
      { all: true },
      { headers },
    );
  };
  render() {
    const {
      step,
      selectedAddress,
      selectedDelivery,
      hasWithoutService,
      selectedBank,
      hasTire,
      nationalCode,
      selectedPayment,
    } = this.state;
    let SubmitButton;
    if (
      (selectedAddress === null || selectedDelivery === null) &&
      hasWithoutService
    ) {
      SubmitButton = (
        <div className="ContinueShopping validation">
          {!selectedAddress
            ? "آدرس خود را انتخاب کنید"
            : "شیوه ارسال را انتخاب کنید"}
        </div>
      );
    } else if (step === "payment" && hasTire && nationalCode.length < 10) {
      SubmitButton = (
        <div className="ContinueShopping validation">
          کد ملی خود را وارد کنید
        </div>
      );
    } else if (
      (step === "payment" && selectedPayment === null) ||
      (selectedPayment === 1 && selectedBank === null)
    ) {
      SubmitButton = (
        <div className="ContinueShopping validation">
          {!selectedPayment
            ? "نحوه پرداخت را انتخاب کنید"
            : selectedPayment === 1 &&
              !selectedBank &&
              "بانک مورد نظر را انتخاب کنید"}
        </div>
      );
    } else {
      SubmitButton = (
        <div className="ContinueShopping">
          <button
            onClick={() => {
              // eslint-disable-next-line no-unused-expressions
              step === "delivery" && this.state.selectedForeignCollect
                ? this.changeStep("payment")
                : step === "payment"
                  ? this.handleSubmit()
                  : null;
            }}
          >
            {this.state.submitLoading ? (
              <PulseLoader color="#fff" size={10} />
            ) : (
              "ادامه خرید"
            )}
          </button>
        </div>
      );
    }

    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <div className="checkout">
            <Header
              showSearchBar={true}
              title={
                this.state.step === "delivery"
                  ? "زمان و نحوه ارسال کالاهای بدون نصب"
                  : "پرداخت"
              }
              ShoppingCartHeader={true}
              backHandler={() => {
                if (
                  this.state.hasWithoutService &&
                  this.state.step === "payment"
                ) {
                  this.changeStep("delivery");
                  return true;
                } else {
                  this.props.history.goBack();
                }
              }}
            />

            {this.state.step === "delivery" && this.state.hasWithoutService ? (
              <>
                <Delivery
                  data={{
                    dTypes: this.state.dTypes,
                    hasWithOutService: this.state.hasWithoutService,
                    selectedAddress: this.state.selectedAddress,
                    selectedDelivery: this.state.selectedDelivery,
                    can_pay_cash: this.state.can_pay_cash,
                    selectedForeignCollect: this.state.selectedForeignCollect,
                    productWithOutSerive: this.state.products.filter(
                      (product) => product.install_need === 0,
                    ),
                  }}
                  methods={{
                    selectedTime: this.selectedTime,
                    changeStep: this.changeStep,
                    handleChangeSelectedForeignCollect:
                      this.handleChangeSelectedForeignCollect,
                    changeDeliveryType: this.changeDeliveryType,
                    changeSelectedAddress: this.changeSelectedAddress,
                  }}
                />
              </>
            ) : (
              <>
                <Payment
                  data={{
                    discountCode: this.state.discountCode,
                    selectedBank: this.state.selectedBank,
                    nationalCode: this.state.nationalCode,
                    description: this.state.description,
                    selectedPayment: this.state.selectedPayment,
                    products: this.state.products,
                    costs: this.state.costs,
                    month: this.state.month,
                    haveOrg: this.state.haveOrg,
                    discountLoading: this.state.discountLoading,
                    hasTire: this.state.hasTire,
                    discountSubmited: this.state.discountSubmited,
                    needLegalFactor: this.state.needLegalFactor,
                  }}
                  methods={{
                    handleChangeNeedLegalFactor:
                      this.handleChangeNeedLegalFactor,
                    changeDiscoutCode: this.changeDiscoutCode,
                    changeBank: this.changeBank,
                    changePaymentType: this.changePaymentType,
                    changeNationalCode: this.changeNationalCode,
                    changeDescription: this.changeDescription,
                    handleSubmit: this.handleSubmit,
                    submitDiscountCode: this.submitDiscountCode,
                    clearDiscountCode: this.clearDiscountCode,
                    handleChangeOrgan: this.handleChangeOrgan,
                    handleFile: this.handleFile,
                    handleInstallmentMonth: this.handleInstallmentMonth,
                  }}
                />
                <PriceWrapper
                  products={this.state.products}
                  costs={this.state.costs}
                />
              </>
            )}
            {SubmitButton}
          </div>
        )}
      </>
    );
  }
}
